module.exports = __webpack_public_path__ + "img/Saison Indonesia.c102552f.png";